import React, { useState, useEffect } from "react";
import { collection, getDocs, addDoc } from "firebase/firestore";
import { productDb } from "../firebaseProducts";
import "../SingleCollectionAdder.css"; // 👈 regular CSS file

const importantFieldsMap = {
  "kids-apparel-menu": [
    "id", "Tags", "Title", "updatedAt", "VariantImage", "back", "PieceCost",
    "Price", "Style#", "Color", "Status2", "Vendor", "Handle", "Style",
    "front", "SUGGESTED_PRICE", "unique_number", "ImageSrc"
  ],
  "kids-apparel": [
    "map2", "id", "piece_price", "weight2", "Weight", "Price", "Type",
    "Style#", "Body", "Size", "ImageAltText", "ImageCircle", "MSRP", "ImageSrc",
    "model", "measure_asli", "Tags", "Title", "colorName4API", "VariantImage",
    "PieceCost", "INDEX", "Color", "PRODUCT_MEASUREMENTS", "Status", "Handle",
    "Vendor", "Style", "front", "DECORATION_SPEC_SHEET", "pms",
    "SUGGESTED_PRICE", "VariantGrams"
  ],
  "kids-accessories-menu": [
    "id", "Title2", "img", "Style#2", "Price", "PieceCost", "Body",
    "FRONT_FLAT", "Handle", "Style", "front", "back"
  ],
  "full-kids-white": [
    "map2", "id", "piece_price", "weight2", "Weight", "Price", "Type", "Style#",
    "Body", "Size", "ImageAltText", "ImageCircle", "MSRP", "ImageSrc", "model",
    "measure_asli", "Tags", "Title", "colorName4API", "VariantImage",
    "PieceCost", "INDEX", "Color", "PRODUCT_MEASUREMENTS", "Status", "Handle",
    "Vendor", "Style", "front", "DECORATION_SPEC_SHEET", "pms",
    "SUGGESTED_PRICE", "VariantGrams"
  ],
  "full-kids-accessories": [
    "id", "Title2", "Style#2", "model2", "Price", "PieceCost", "Weight", "Body",
    "Size", "FRONT_FLAT", "Handle", "Style", "VariantGrams", "ImageSrc"
  ],
  "full-drinkwear": [
    "id", "JDS_STYLE", "Weight", "Price", "Type", "Style#", "Body", "ImageAltText",
    "ImageSrc", "Title", "VariantImage", "Our_Handle", "PieceCost", "back",
    "Color", "Handle", "Vendor", "Style", "front", "MinQty", "VariantGrams"
  ],
  "kids-apparel-white-menu": [
    "AVAILABLE_SIZES", "id", "model", "Tags", "Title", "VariantImage", "Weight",
    "Price", "PieceCost", "Type", "Style#", "Color", "Body", "Size",
    "PRODUCT_MEASUREMENTS", "ImageAltText", "Vendor", "Handle", "Style", "front",
    "MSRP", "SUGGESTED_PRICE", "ImageSrc", "VariantGrams"
  ],
  "adult-apparel": [
    "id", "weight2", "Weight", "Price", "Style#", "Body", "Size", "companion",
    "ImageAltText", "ImageCircle", "MSRP", "ImageSrc", "AVAILABLE_SIZES",
    "model", "measure_asli", "Title", "colorName4API", "VariantImage", "PieceCost",
    "FRONT_MODEL", "Color", "PRODUCT_MEASUREMENTS", "Handle", "Vendor", "Style",
    "front", "DECORATION_SPEC_SHEET", "SUGGESTED_PRICE", "VariantGrams"
  ],
  "adult-accessories-list-menu": [
    "id", "Tags", "Title2", "img", "Style#2", "updatedAt", "PieceCost", "Price",
    "Body", "Size", "Color", "PRODUCT_MEASUREMENTS", "FRONT_FLAT", "Handle",
    "Vendor", "Style", "front", "SUGGESTED_PRICE"
  ],
  "full-adult-accessories": [
    "id", "weight2", "Weight", "Price", "Style#", "Body", "Size", "companion",
    "ImageAltText", "ImageCircle", "MSRP", "ImageSrc", "model", "measure_asli",
    "Title", "colorName4API", "Category", "VariantImage", "PieceCost",
    "FRONT_MODEL", "Color", "PRODUCT_MEASUREMENTS", "Handle", "Vendor", "Style",
    "front", "Size_value", "DECORATION_SPEC_SHEET", "SUGGESTED_PRICE", "VariantGrams"
  ],
  "adult-list-menu": [
    "id", "AVAILABLE_SIZES", "Tags", "Title2", "img", "Style#2", "updatedAt",
    "PieceCost", "Price", "Body", "Size", "Color", "PRODUCT_MEASUREMENTS",
    "FRONT_FLAT", "Handle", "Vendor", "Style", "front", "SUGGESTED_PRICE"
  ],
  "drinkwear-menu": [
    "JDS_Handle", "Variant_Grams", "case", "id", "tt", "Title2", "img", "Style#2",
    "MinQnt", "VariantImage", "JDS_STYLE", "PieceCost", "Variant_Image", "Weight",
    "Type", "Price", "Body", "Size", "Color", "FRONT_FLAT", "BACK_FLAT", "Handle",
    "ImageAltText", "Style", "front", "_VariantGrams_"
  ]
};

const SingleCollectionAdder = () => {
  const [collectionChoice, setCollectionChoice] = useState("");
  const [fields, setFields] = useState([]);
  const [formData, setFormData] = useState({});
  const [loadingFields, setLoadingFields] = useState(false);
  const [addingDocument, setAddingDocument] = useState(false);

  useEffect(() => {
    if (!collectionChoice) {
      setFields([]);
      setFormData({});
      return;
    }

    const fetchFields = async () => {
      setLoadingFields(true);
      try {
        const snap = await getDocs(collection(productDb, collectionChoice));
        const fieldSet = new Set();

        snap.forEach((doc) => {
          Object.keys(doc.data()).forEach((key) => fieldSet.add(key));
        });

        const fieldList = [...fieldSet];
        setFields(fieldList);
        setFormData(Object.fromEntries(fieldList.map((f) => [f, ""])));
      } catch (err) {
        console.error("Failed to fetch fields", err);
        setFields([]);
        setFormData({});
      }
      setLoadingFields(false);
    };

    fetchFields();
  }, [collectionChoice]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleAddDocument = async () => {
    if (!collectionChoice) return alert("Select a collection first");
    if (fields.length === 0) return alert("No fields available to add");

    setAddingDocument(true);

    try {
      const dataToSave = {};
      Object.keys(formData).forEach((key) => {
        dataToSave[key] = formData[key] === "" ? null : formData[key];
      });

      await addDoc(collection(productDb, collectionChoice), dataToSave);
      alert(`✅ Document added to ${collectionChoice} successfully!`);
      setFormData(Object.fromEntries(fields.map((f) => [f, ""])));
    } catch (err) {
      console.error("Failed to add document", err);
      alert("Error adding document");
    }

    setAddingDocument(false);
  };

  return (
    <div className="form-container">
      <h1 className="warning-text">Needs to be tested!!!!</h1>
      <h2 className="form-title">Add Document to Collection</h2>

      <select
        value={collectionChoice}
        onChange={(e) => setCollectionChoice(e.target.value)}
        className="collection-select"
      >
        <option value="">Select Collection</option>
        {Object.keys(importantFieldsMap).map((key) => (
          <option key={key} value={key}>
            {key}
          </option>
        ))}
      </select>

      {loadingFields && <p className="loading-text">Loading fields...</p>}

      {!loadingFields && fields.length > 0 ? (
        fields.map((field) => {
          const isImportant = importantFieldsMap[collectionChoice]?.includes(field);
          return (
            <input
              key={field}
              type="text"
              placeholder={isImportant ? `${field} *` : field}
              value={formData[field] || ""}
              onChange={(e) => handleChange(field, e.target.value)}
              className={`field-input ${isImportant ? "important" : ""}`}
            />
          );
        })
      ) : (
        !loadingFields &&
        collectionChoice && <p className="loading-text">No fields available.</p>
      )}

      <button
        onClick={handleAddDocument}
        disabled={addingDocument || loadingFields || fields.length === 0}
        className="add-button"
      >
        {addingDocument ? "Adding..." : "Add Document"}
      </button>
    </div>
  );
};

export default SingleCollectionAdder;
